export default {"src":"/_next/static/media/PencilEdit.16ad6135.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};